export default {
	"alert.dialog.yes": "Ja",
	"alert.dialog.no": "Nein",
} as const;
